import {connect} from "react-redux";
import {compose} from "redux";
import {WithAppendHeaderAndFooterHOC} from "../../../HOC/WithAppendHeaderAndFooterHOC";
import NotFound from "./NotFound";
import {WithAppendSidebarHOC} from "../../../HOC/WithAppendSidebarHOC";


let mapStateToProps = (state) => {
    return {}
};

let mapDispatchToProps = (dispatch) => {
    return {}
};

export default compose(connect(mapStateToProps, mapDispatchToProps), WithAppendSidebarHOC, WithAppendHeaderAndFooterHOC)(NotFound);



